import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import "./Login.css";
import logo from "../kungfu_logo.png";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const nav = useNavigate();
  const loc = useLocation();
  const from = loc.state?.from?.pathname || "/overview";

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      nav(from, { replace: true });
    } catch (e) {
      setErr(e.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-auth-wrap">
      <div className="login-auth-card">
        <div className="login-auth-brand">
          <img src={logo} alt="KFD" />
          <div className="brand-text">
            <div className="brand-title">KFD All Store Platform</div>
            <div className="brand-sub">Sign in to continue</div>
          </div>
        </div>

        <form onSubmit={onSubmit} className="login-auth-form">
          <label>Username</label>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
          />
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          {err && <div className="login-auth-error">{err}</div>}
          <button type="submit" disabled={loading}>
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>

      {/* ===== 在这里加备案号 footer ===== */}
      <footer className="login-footer">
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >
          京ICP备2024045455号-1
        </a>
      </footer>
    </div>
  );
}
